module.exports = __webpack_public_path__ + "static/media/details-3.822c0090.jpeg";